/*
 * some comment here
 */
export const test = true;
export function foo() {
  return 1;
}
export function bar() {
  return 2;
}
